// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-templates-static-page-jsx" + "-" + "95fee01b819330b8f493" + ".js";
};